import React from 'react';
import classNames from 'classnames';

/**
 * Lightweight replacement for react-custom-scrollbars (React 18 compatible).
 */
export function Scrollbars({
	children,
	className,
	style,
	autoHeight,
	autoHeightMin,
	autoHeightMax,
	autoHide,
}) {
	const scrollStyle = { ...style };

	if (autoHeight) {
		scrollStyle.overflowY = 'auto';
		if (autoHeightMin != null) {
			scrollStyle.minHeight = autoHeightMin;
		}
		if (autoHeightMax != null) {
			scrollStyle.maxHeight = autoHeightMax;
		}
	} else if (!scrollStyle.overflow && !scrollStyle.overflowY) {
		scrollStyle.overflowY = 'auto';
	}

	return (
		<div
			className={classNames(className, { 'rct-scroll-auto-hide': autoHide })}
			style={scrollStyle}
		>
			{children}
		</div>
	);
}

export default Scrollbars;
